import { zodResolver } from '@hookform/resolvers/zod'
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from '@material-ui/core'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

import Button from '@/components/button'
import { saveDemandAnalysisDecisionAnswer } from '@/services/demand-analysis-decision-answer'

import { useStyles } from './style'

const decisionSchema = z.object({
  rememberAnswer: z.boolean(),
})

type DecisionSchema = z.infer<typeof decisionSchema>

interface DecisionModalProps {
  variant: 'edition' | 'substitution'
  open: boolean
  onClose?: () => void
  onSubmit?: () => void
}

export const DecisionModal = ({
  variant,
  open,
  onClose,
  onSubmit,
}: DecisionModalProps) => {
  const classes = useStyles()

  const { handleSubmit, register } = useForm<DecisionSchema>({
    resolver: zodResolver(decisionSchema),
  })

  function onSubmitForm(data: DecisionSchema) {
    if (data.rememberAnswer) {
      saveDemandAnalysisDecisionAnswer(variant, data.rememberAnswer)
    }

    onSubmit?.()
  }

  const variants = {
    edition: {
      title: 'Salvar edição',
      description:
        'Ao salvar a edição substituiremos os arquivos para o processamento do seu diagnóstico. Essa alteração não irá refletir na propriedade e projetos já cadastrados na plataforma',
    },
    substitution: {
      title: 'Substituir arquivos',
      description:
        'Ao confirmar a substituição, os arquivos atuais serão trocados para análise sem afetar os registros prévios.',
    },
  }

  const { title, description } = variants[variant]

  return (
    <Dialog
      open={open}
      onClose={onClose}
      classes={{
        paper: classes.main,
      }}
      PaperProps={{
        component: 'form',
        onSubmit: handleSubmit(onSubmitForm),
      }}
    >
      <DialogTitle disableTypography classes={{ root: classes.dialogTitle }}>
        <span className='material-symbols-outlined'>upload_file</span>
        <Typography variant={'h2'}>{title}</Typography>
      </DialogTitle>
      <DialogContent
        classes={{
          root: classes.dialogContent,
        }}
      >
        <ul>
          <Typography component={'li'}>{description}</Typography>
        </ul>

        <FormControlLabel
          control={<Checkbox {...register('rememberAnswer')} />}
          label='Lembrar minha resposta, não perguntar novamente'
        />
      </DialogContent>
      <DialogActions
        classes={{
          root: classes.dialogActions,
        }}
      >
        <Button onClick={onClose} outlined>
          Cancelar
        </Button>

        <Button type='submit'>{title}</Button>
      </DialogActions>
    </Dialog>
  )
}
